module.exports = __webpack_public_path__ + "img/calculator.11bbd998.svg";